'use client';
import {formPreviewHash} from '@/lib/utils';
import {useTranslations} from 'next-intl';
import {useSearchParams} from 'next/navigation';
import PageLayout from '../PageLayout';

export default function ErrorPage() {
  const t = useTranslations('Error');
  const reset = () => {
    window.location.reload();
  };
  const searchParams = useSearchParams();
  const errorCode = searchParams.get('code');

  let errors: any = {};
  errors[formPreviewHash('contain-invalid-char')] = t.rich(
    'contain-invalid-char',
    {p: (chunks) => <p className="">{chunks}</p>}
  );
  errors[formPreviewHash('internal-error')] = t.rich('internal-error', {
    p: (chunks) => <p className="">{chunks}</p>,
    retry: (chunks) => (
      <a className="text-red-500 underline underline-offset-2" href="/">
        {chunks}
      </a>
    )
  });

  return (
    <PageLayout title={t('title')}>
      <div className="flex flex-col items-center justify-center my-[10vh]">
        <h1 className="text-3xl font-bold my-4 text-[#e22319]">{t('title')}</h1>

        <div className="max-w-[460px] text-center ">
          {(errorCode && errors[errorCode]) ||
            t.rich('description', {
              p: (chunks) => <p className="">{chunks}</p>,
              retry: (chunks) => (
                <button
                  className="text-red-500 underline underline-offset-2"
                  onClick={reset}
                  type="button"
                >
                  {chunks}
                </button>
              )
            })}
        </div>
      </div>
    </PageLayout>
  );
}
